<template>
  <div class="shop-map-container">
    <div ref="map" class="map-view"></div>

    <!-- 遮罩層 -->
    <div v-if="selectedShop" class="shop-overlay" @click="closeShopInfo"></div>

    <!-- 商店資訊卡片 -->
    <div v-if="selectedShop" class="shop-info-card" @click.stop>
      <button class="close-btn" @click="closeShopInfo">×</button>

      <div class="shop-card-content">
        <!-- 商店圖片 -->
        <div class="shop-image">
          <img :src="selectedShop.image || defaultImage" :alt="selectedShop.name" />
          <div v-if="!selectedShop.isEnabled" class="cover-mask">
            暫不供應
          </div>
        </div>

        <!-- 商店資訊 -->
        <div class="shop-details">
          <div class="shop-header">
            <h3 class="shop-name">{{ selectedShop.name }}</h3>
            <div v-if="!selectedShop.isEnabled" class="shop-status stop-open">
              暫不供應
            </div>
          </div>

          <!-- 地址 -->
          <div class="shop-address" @click="openGoogleMaps">
            <i class="icon-location"></i>
            <span>{{ selectedShop.address }}</span>
          </div>

          <!-- 營業資訊 -->
          <div v-if="selectedShop.info" class="shop-info">
            <div class="info-label">營業資訊：</div>
            <div class="info-content" v-html="selectedShop.info"></div>
          </div>

          <!-- 取餐方式 -->
          <div class="shop-services">
            <span class="label">取餐方式：</span>
            <i v-if="selectedShop.isDelivery" class="icon_delivery">送</i>
            <i v-if="selectedShop.isTakeout" class="icon_self">自</i>
            <i v-if="selectedShop.isEatIn" class="icon_inside">內</i>
          </div>

          <!-- 付款方式 -->
          <div class="shop-payment">
            <span class="label">付款方式：</span>
            <i v-if="hasPaymentMethod('linepay')" class="icon_linepay"></i>
            <i v-if="hasPaymentMethod('googlepay')" class="icon_googlepay"></i>
            <i v-if="hasPaymentMethod('applepay')" class="icon_applepay"></i>
            <i v-if="hasPaymentMethod('credit')" class="icon_creditcard"></i>
            <i v-if="hasPaymentMethod('easywallet')" class="icon_easywallet"></i>
            <i v-if="hasPaymentMethod('taiwanpay')" class="icon_taiwanpay"></i>
            <i v-if="hasPaymentMethod('jkopay')" class="icon_jkopay"></i>
            <i v-if="hasPaymentMethod('icashpay')" class="icon_icash"></i>
            <i v-if="hasPaymentMethod('pxpay')" class="icon_pxpay"></i>
            <i v-if="hasPaymentMethod('pxpayplus')" class="icon_pxpay"></i>
            <i v-if="hasPaymentMethod('pluspay')" class="icon_pluspay"></i>
            <i v-if="selectedShop.isCash" class="icon_cash"></i>
          </div>

          <!-- QR 掃碼點餐 - 已點清單按鈕 -->
          <div v-if="qrInfo && qrInfo.listUrl" class="qr-button-bar">
            <a class="ordered-list-btn" :href="qrInfo.listUrl">
              <i class="icon-list"></i>已點清單
            </a>
          </div>

          <!-- 熱銷商品 -->
          <div v-if="topProducts && topProducts.length" class="hot-sale">
            <div class="hot-sale-title">熱銷商品</div>
            <div class="hot-sale-items">
              <div v-for="(product, index) in topProducts" :key="product.id" class="hot-sale-item">
                <div class="product-image">
                  <img v-if="product.image" :src="product.image" :alt="product.name" />
                </div>
                <div class="product-name">{{ product.name }}</div>
                <div class="product-price">${{ product.price }}</div>
                <div class="product-rank">{{ index + 1 }}</div>
              </div>
            </div>
          </div>

          <!-- 操作按鈕 -->
          <!-- type === 'QrShop': QR 掃碼點餐 -->
          <template v-if="type === 'QrShop'">
            <a
              v-if="qrInfo && qrInfo.menuUrl"
              class="view-menu-btn"
              :href="qrInfo.menuUrl"
            >
              我要{{ selectedShop.shopCategory === 'retail' ? '買東西' : '點餐' }} <i class="icon-arrow-right"></i>
            </a>
          </template>
          <!-- type !== 'QrShop' && type !== 'LineShop': 一般商店（main 區塊邏輯） -->
          <template v-else-if="type !== 'QrShop' && type !== 'LineShop'">
            <!-- portalLinkType === 'web': 使用 webLink -->
            <a
              v-if="selectedShop.portalLinkType === 'web' && selectedShop.webLink"
              class="view-menu-btn"
              :href="selectedShop.webLink"
            >
              我要{{ selectedShop.shopCategory === 'retail' ? '買東西' : '點餐' }} <i class="icon-arrow-right"></i>
            </a>
            <!-- portalLinkType === 'line': 加LINE好友 -->
            <a
              v-else-if="selectedShop.portalLinkType === 'line' && selectedShop.link"
              class="view-menu-btn line-friend-btn"
              :href="selectedShop.link"
            >
              加LINE好友．線上逛 <i class="icon-arrow-right"></i>
            </a>
            <!-- 其他: 使用 link -->
            <a
              v-else-if="selectedShop.link"
              class="view-menu-btn"
              :href="selectedShop.link"
            >
              我要{{ selectedShop.shopCategory === 'retail' ? '買東西' : '點餐' }} <i class="icon-arrow-right"></i>
            </a>
          </template>
          <!-- type === 'LineShop': footer 區塊邏輯 -->
          <template v-else>
            <!-- portalLinkType !== 'line': 一般點餐/購物 -->
            <a
              v-if="selectedShop.portalLinkType !== 'line' && selectedShop.link && !selectedShop.hideLink"
              class="view-menu-btn"
              :href="selectedShop.link"
            >
              我要{{ selectedShop.shopCategory === 'retail' ? '買東西' : '點餐' }} <i class="icon-arrow-right"></i>
            </a>
            <!-- portalLinkType === 'line': 加LINE好友 -->
            <a
              v-if="selectedShop.portalLinkType === 'line' && selectedShop.link"
              class="view-menu-btn line-friend-btn"
              :href="selectedShop.link"
            >
              加LINE好友．線上逛 <i class="icon-arrow-right"></i>
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "../services/apis";
import pin from '../assets/images/svg/pin.svg';
import pinGrey from '../assets/images/svg/pin-grey.svg';

export default {
  name: "ShopMap",
  props: {
    shops: {
      type: Array,
      default: () => []
    },
    center: {
      type: Object,
      default: () => ({ lat: 25.0330, lng: 121.5654 }) // 台北市中心
    },
    zoom: {
      type: Number,
      default: 13
    },
    type: {
      type: String,
      default: 'Shop' // 'Shop', 'QrShop', 'LineShop'
    },
    showPopup: {
      type: Boolean,
      default: false // true: 顯示彈窗, false: 直接跳轉到商店頁面
    }
  },
  data() {
    return {
      map: null,
      markers: [],
      selectedShop: null,
      defaultImage: GLOBAL_DEFAULT_SHOP_IMG,
      infoWindow: null,
      topProducts: [],
      qrInfo: null,
      currentMapCenter: null,
      currentMapZoom: null,
      shouldRestoreMapState: false, // 標記是否應該恢復地圖狀態
      hasRestoredState: false // 標記是否已經恢復過狀態
    };
  },
  mounted() {
    // 檢查是否有保存的地圖狀態
    console.log('ShopMap mounted');
    const savedMapState = localStorage.getItem('mapState');
    if (savedMapState) {
      try {
        const mapState = JSON.parse(savedMapState);
        this.shouldRestoreMapState = true;
        this.currentMapCenter = mapState.center;
        this.currentMapZoom = mapState.zoom;
      } catch (e) {
        console.error('Failed to parse saved map state:', e);
        localStorage.removeItem('mapState');
      }
    }

    this.initMap();
  },
  watch: {
    shops: {
      handler(newShops) {
        this.updateMarkers();
      },
      deep: true
    },
    center: {
      handler(newCenter) {
        if (this.map && newCenter) {
          this.map.setCenter(newCenter);
        }
      },
      deep: true
    },
    selectedShop: {
      handler(newShop) {
        // 當彈窗開啟或關閉時，控制背景滾動
        if (newShop) {
          // 開啟彈窗：禁止背景滾動
          document.body.style.overflow = 'hidden';
        } else {
          // 關閉彈窗：恢復背景滾動
          document.body.style.overflow = '';
        }
      }
    }
  },
  methods: {
    hasPaymentMethod(method) {
      if (!this.selectedShop || !this.selectedShop.isMobilePayment) {
        return false;
      }
      if (!this.selectedShop.paymentOptions || !this.selectedShop.paymentOptions.methods) {
        return false;
      }
      return this.selectedShop.paymentOptions.methods.includes(method);
    },
    initMap() {
      // 載入 Google Maps API
      if (!window.google) {
        this.loadGoogleMapsAPI().then(() => {
          this.createMap();
        });
      } else {
        this.createMap();
      }
    },
    loadGoogleMapsAPI() {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        // 請替換成您的 Google Maps API Key
        const apiKey = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || 'YOUR_API_KEY';
        // 優化：移除未使用的 Places Library，避免不必要的成本
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    createMap() {
      // 如果有保存的地圖狀態，使用保存的狀態；否則使用 props
      const mapOptions = {
        center: this.shouldRestoreMapState && this.currentMapCenter ? this.currentMapCenter : this.center,
        zoom: this.shouldRestoreMapState && this.currentMapZoom ? this.currentMapZoom : this.zoom,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControl: true
      };

      this.map = new google.maps.Map(this.$refs.map, mapOptions);

      // 監聽地圖縮放變化
      this.map.addListener('zoom_changed', () => {
        this.currentMapZoom = this.map.getZoom();
      });

      // 監聽地圖中心點變化
      this.map.addListener('center_changed', () => {
        const center = this.map.getCenter();
        if (center) {
          this.currentMapCenter = {
            lat: center.lat(),
            lng: center.lng()
          };
        }
      });

      this.updateMarkers();
    },
    updateMarkers() {
      if (!this.map) return;

      // 清除舊的標記
      this.markers.forEach(marker => marker.setMap(null));
      this.markers = [];

      // 用於追踪相同位置的店家
      const positionMap = new Map();
      let bounds = null; // Initialize bounds here

      // 為每個店家創建標記
      this.shops.forEach((shop) => { // Changed from displayShops and store
        // Ensure lat and lng exist and are valid numbers
        if (shop.lat === null || shop.lng === null || shop.lat === undefined || shop.lng === undefined) return;

        let lat = parseFloat(shop.lat);
        let lng = parseFloat(shop.lng);

        if (isNaN(lat) || isNaN(lng)) return;

        const originalPositionKey = `${lat},${lng}`;
        let currentLat = lat;
        let currentLng = lng;

        // 檢查是否有其他店家在完全相同的位置
        if (positionMap.has(originalPositionKey)) {
          // 如果有重複位置，稍微偏移座標（很小的偏移量，僅用於區分完全相同的位置）
          const offsetCount = positionMap.get(originalPositionKey); // Get current offset count for this position
          const offsetAmount = 0.00001; // 約 8-10 公尺的偏移

          // 使用圓形偏移模式
          const angle = (offsetCount * 60) * (Math.PI / 180); // 每個標記相隔 60 度
          currentLat += offsetAmount * Math.cos(angle);
          currentLng += offsetAmount * Math.sin(angle);

          positionMap.set(originalPositionKey, offsetCount + 1); // Increment offset count
          // console.log(`[updateMarkers] Offset marker for ${shop.name} at duplicate position (offsetCount: ${offsetCount})`);
        } else {
          positionMap.set(originalPositionKey, 1); // First shop at this position
        }

        const position = { lat: currentLat, lng: currentLng }; // Use the potentially jittered coordinates

        const marker = new google.maps.Marker({
          position: position, // Use the jittered position
          map: this.map,
          title: shop.name,
          icon: {
            url: this.getMarkerIcon(shop), // Use existing method for icon
            scaledSize: new google.maps.Size(40, 40)
            // anchor: new google.maps.Point(20, 40) // Omitted for consistency with existing code
          }
        });

        marker.addListener('click', () => {
          this.selectShop(shop);
          this.map.panTo(position); // Pan to the jittered position
          // if (this.zoomOnMarkerClick) { // Omitted for consistency with existing code
          //   this.map.setZoom(15);
          // }
        });

        this.markers.push(marker);

        // 初始化或擴展 bounds
        if (!bounds) {
          bounds = new google.maps.LatLngBounds();
        }
        bounds.extend(position); // Extend bounds with the jittered position
      });

      // 調整地圖視野以包含所有標記
      // 但如果應該恢復地圖狀態，則跳過 fitBounds 以保持使用者離開前的視野
      if (this.markers.length > 0 && !this.shouldRestoreMapState) {
        if (bounds) { // Only fit if bounds were initialized
          this.map.fitBounds(bounds);
        }

        // If all markers are at the same spot, fitBounds might zoom in too much.
        // Add a check to prevent excessive zoom.
        if (this.map.getZoom() > 16) {
          this.map.setZoom(16);
        }
      }

      // 標記已經恢復過狀態，下次更新標記時就不需要再跳過 fitBounds 了
      if (this.shouldRestoreMapState && !this.hasRestoredState) {
        this.hasRestoredState = true;
        this.shouldRestoreMapState = false;
        // 清除 localStorage 中的地圖狀態，避免影響下次進入頁面
        localStorage.removeItem('mapState');
      }
    },
    getMarkerIcon(shop) {
      // 根據商店狀態返回不同的標記圖示
      if (!shop.isEnabled) {
        return pinGrey;
      }

      return pin;
    },
    selectShop(shop) {
      this.$emit('shop-selected', shop);

      if (!shop || !shop.id) return;

      // 如果 showPopup 為 false，直接跳轉到商店頁面
      if (!this.showPopup) {
        this.navigateToShop(shop);
        return;
      }

      // 顯示彈窗模式
      // 先設定基本的 shop 資料，這樣彈窗可以立即顯示
      this.selectedShop = shop;

      // 清空之前的資料
      this.topProducts = [];
      this.qrInfo = null;

      if (shop && shop.id) {
        const self = this;
        const portalId = this.$route.query.p;

        // 同時取得 Portal 設定和商店資訊
        const tasks = [
          apis.getPortalInfo(portalId),
          apis.getShopInfo(shop.id)
        ];

        Promise.all(tasks).then((responses) => {
          const portal = responses[0];
          let shopData = responses[1];

          if (shopData) {
            // 處理 portalLinkType (參考 Shop.vue:403-404)
            if (portal && portal.linkType === "OA") {
              shopData.portalLinkType = "line";
            } else if (portal && portal.linkType === "WEB") {
              shopData.portalLinkType = "web";
            }

            // 處理 shop.link，加上 source 參數 (參考 Shop.vue:406-416)
            if (shopData.link && shopData.portalLinkType !== "line") {
              if (self.type === 'LineShop' && navigator.userAgent.indexOf("Line") > -1) {
                // 用LINE的瀏覽器開的話，都要求開OA
                shopData.link = shopData.lineAddFriendUrl;
                shopData.hideLink = true;
              } else {
                shopData.link += "&source=" + portalId;
              }
            } else if (shopData.lineAddFriendUrl) {
              shopData.link = shopData.lineAddFriendUrl;
            }

            // 處理 ssoUrl (參考 Shop.vue:418)
            if (shopData.ssoAppId) {
              shopData.ssoUrl = "/bcs?app=" + shopData.ssoAppId;
            }

            // 處理換行符號 (參考 Shop.vue:420-423)
            if (shopData.info) {
              shopData.info = shopData.info.replace(/\n/g, "<br>");
            }

            // 更新 selectedShop 為完整的商店資料
            // 保留原有的 lat, lng 等地圖相關資料
            self.selectedShop = {
              ...shop,
              ...shopData
            };
          }
        }).catch((error) => {
          console.error('Failed to fetch shop info or portal info:', error);
        });

        // 獲取熱銷商品
        apis.getTopProducts(shop.id).then((products) => {
          this.topProducts = products || [];
        }).catch((error) => {
          console.error('Failed to fetch top products:', error);
          this.topProducts = [];
        });

        // 獲取 QR 掃碼資訊（如果有 qrId）
        const qrId = this.$route.query.q;
        if (qrId) {
          apis.getQrInfo(qrId).then((qrData) => {
            this.qrInfo = qrData || null;

            // 如果已經結帳，直接跳轉到訂單頁面
            if (this.qrInfo && this.qrInfo.orderUrl) {
              window.location.href = this.qrInfo.orderUrl;
            }
          }).catch((error) => {
            console.error('Failed to fetch QR info:', error);
            this.qrInfo = null;
          });
        }
      }
    },
    navigateToShop(shop) {
      // 保存當前地圖狀態到 localStorage
      const mapState = {
        center: this.currentMapCenter || {
          lat: this.map.getCenter().lat(),
          lng: this.map.getCenter().lng()
        },
        zoom: this.currentMapZoom || this.map.getZoom()
      };
      localStorage.setItem('mapState', JSON.stringify(mapState));

      // 根據當前 route 的 path 決定跳轉路徑
      const currentPath = this.$route.path;
      let path = '';

      if (currentPath.startsWith('/togo')) {
        path = `/togo/${shop.id}`;
      } else if (currentPath.startsWith('/delivery')) {
        path = `/delivery/${shop.id}`;
      } else if (currentPath.startsWith('/foods')) {
        path = `/foods/${shop.id}`;
      } else if (currentPath.startsWith('/all-shops')) {
        path = `/all-shops/${shop.id}`;
      } else if (currentPath.startsWith('/shopping')) {
        path = `/shopping/${shop.id}`;
      } else {
        // 預設使用 delivery
        path = `/delivery/${shop.id}`;
      }

      // 保留當前的 query 參數
      this.$router.push({
        path: path,
        query: this.$route.query
      });
    },
    closeShopInfo() {
      this.selectedShop = null;
      this.topProducts = [];
      this.qrInfo = null;
    },
    openGoogleMaps() {
      if (this.selectedShop && this.selectedShop.address) {
        const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.selectedShop.address)}`;
        window.open(url, '_blank');
      }
    },
  },
  // keep-alive 專用生命週期：組件被隱藏時清理 UI 狀態
  deactivated() {
    console.log('ShopMap deactivated');
    // 關閉商店資訊彈窗
    if (this.selectedShop) {
      this.closeShopInfo();
    }
  },
  // 組件真正銷毀時的清理（非 keep-alive 或組件被移除時）
  beforeDestroy() {
    console.log('ShopMap beforeDestroy');
    
    // 清理標記及其事件監聽器
    this.markers.forEach(marker => {
      // 清除 marker 的所有事件監聽器（防止記憶體洩漏）
      if (window.google && window.google.maps && window.google.maps.event) {
        window.google.maps.event.clearInstanceListeners(marker);
      }
      marker.setMap(null);
    });
    this.markers = [];

    // 清理地圖的所有事件監聽器（防止記憶體洩漏）
    if (this.map && window.google && window.google.maps && window.google.maps.event) {
      window.google.maps.event.clearInstanceListeners(this.map);
    }

    // 恢復背景滾動
    document.body.style.overflow = '';
  }
};
</script>

<style scoped>
.shop-map-container {
  position: relative;
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  height: calc(100vh - 200px);
  min-height: 400px;
}

.map-view {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.shop-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.shop-info-card {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateX(-50%) translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  z-index: 11;
  transition: background 0.2s;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}

.shop-card-content {
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 0;
  max-height: 70vh;
}

.shop-image {
  position: relative;
  width: 100%;
  height: 180px;
  overflow: hidden;
  background: #f3f3f3 url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23ccc'%3E%3Cpath d='M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z'/%3E%3C/svg%3E") no-repeat center;
  background-size: 30%;
  flex-shrink: 0;
}

.shop-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cover-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: 500;
}

.shop-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px 15px 0 15px;
  overflow-y: auto;
  min-height: 0;
}

.shop-details > *:not(.view-menu-btn) {
  flex-shrink: 0;
}

.shop-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.shop-name {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #282828;
  flex: 1;
}

.shop-status {
  font-size: 12px;
  white-space: nowrap;
}

.shop-status.stop-open {
  color: #CB5A4B;
}

.shop-address {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  cursor: pointer;
}

.shop-address:hover {
  color: #5CBD36;
}

.shop-address i {
  flex-shrink: 0;
  margin-top: 2px;
}

.shop-info {
  font-size: 13px;
  line-height: 1.6;
}

.info-label {
  font-weight: 500;
  color: #282828;
  margin-bottom: 4px;
}

.info-content {
  color: #666;
  white-space: pre-line;
}

.shop-services,
.shop-payment {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
  font-size: 13px;
}

.shop-services .label,
.shop-payment .label {
  font-weight: 500;
  color: #282828;
  flex-shrink: 0;
}

.shop-services i {
  display: inline-block;
  padding: 2px 6px;
  font-size: 12px;
  color: white;
  border-radius: 3px;
  font-weight: 500;
  font-style: normal;
}

.icon_delivery {
  background: #CB5A4B;
}

.icon_self {
  background: #f0941d;
}

.icon_inside {
  background: #d9b216;
}

.shop-payment i {
  display: inline-block;
  width: 50px;
  height: 18px;
  border-radius: 3px;
}

.qr-button-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.ordered-list-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 8px 20px;
  background: #f0941d;
  color: white;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.2s;
}

.ordered-list-btn:hover {
  background: #d97f0c;
}

.ordered-list-btn i {
  font-size: 16px;
}

.icon_cash {
  background: #F3F3F3 url("../assets/images/svg/cash.svg") no-repeat center;
  background-size: 70%;
}

.icon_creditcard {
  background: #F3F3F3 url("../assets/images/svg/creditcard.svg") no-repeat center;
  background-size: 25%;
}

.icon_applepay {
  background: #F3F3F3 url("../assets/images/svg/applepay.svg") no-repeat center;
  background-size: 50%;
}

.icon_googlepay {
  background: #F3F3F3 url("../assets/images/svg/googlepay.svg") no-repeat center;
  background-size: 50%;
}

.icon_linepay {
  background: #F3F3F3 url("../assets/images/svg/linepay.svg") no-repeat center;
  background-size: 70%;
}

.icon_easywallet {
  background: #F3F3F3 url("../assets/images/svg/easywallet.svg") no-repeat center;
  background-size: 72%;
}

.icon_taiwanpay {
  background: #F3F3F3 url("../assets/images/svg/taiwanpay.png") no-repeat center;
  background-size: 82%;
}

.icon_jkopay {
  background: #F3F3F3 url("../assets/images/svg/jkopay.svg") no-repeat center;
  background-size: 70%;
}

.icon_icash {
  background: #F3F3F3 url("../assets/images/svg/icash.svg") no-repeat center;
  background-size: 80%;
}

.icon_pxpay {
  background: #ffd100 url("../assets/images/svg/pxpay.png") no-repeat center;
  background-size: 80%;
}

.icon_pluspay {
  background: #F3F3F3 url("../assets/images/svg/pluspay.png") no-repeat center;
  background-size: 75%;
}

.hot-sale {
  width: 100%;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.hot-sale-title {
  font-size: 14px;
  font-weight: 600;
  color: #282828;
  margin-bottom: 10px;
}

.hot-sale-items {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 5px;
}

.hot-sale-items::-webkit-scrollbar {
  height: 4px;
}

.hot-sale-items::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 2px;
}

.hot-sale-item {
  position: relative;
  flex-shrink: 0;
  width: 100px;
  text-align: center;
}

.product-image {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  background: #f3f3f3;
  margin-bottom: 5px;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-name {
  font-size: 12px;
  color: #282828;
  margin-bottom: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-price {
  font-size: 13px;
  font-weight: 600;
  color: #CB5A4B;
}

.product-rank {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.view-menu-btn {
  width: calc(100% + 30px);
  padding: 12px 20px;
  background: #5CBD36;
  color: white;
  border: none;
  border-radius: 0 0 12px 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: background 0.2s;
  text-decoration: none;
  position: sticky;
  bottom: 0;
  margin: 15px -15px 0 -15px;
  flex-shrink: 0;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.view-menu-btn:hover {
  background: #4CAD2A;
}

.view-menu-btn i {
  font-size: 14px;
}

.line-friend-btn {
  background: #06C755;
}

.line-friend-btn:hover {
  background: #05B34C;
}

/* 手機版樣式 */
@media (max-width: 768px) {
  .shop-info-card {
    width: 95%;
    max-width: none;
  }

  .shop-card-content {
    flex-direction: column;
    padding: 12px;
  }

  .shop-image {
    width: 100%;
    height: 200px;
  }
}
</style>
